import CustomText from "@components/CustomText";
import color from "@constants/color";
import React from "react";
import { View } from "react-native";
import Info from "@assets/svg/MyDeliveries/Info";
import ChevronRight from "@assets/svg/ChevronRight";
import { IssuesToReturn } from "@constants/cplp";

const getReturnQty = (current_state) => {
  let totalQuantity = 0;
  IssuesToReturn.forEach((i) => {
    if (current_state[i]) {
      totalQuantity += current_state[i];
    }
  });
  return totalQuantity;
};

const ItemsToReturnStrip = ({
  return_quantity,
  current_state,
  isClickable = false,
}) => {
  const returnQty = return_quantity || getReturnQty(current_state);
  return returnQty ? (
    <View
      style={{
        padding: 13,
        borderRadius: 12,
        backgroundColor: "#FFF2E5",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <View style={{ flexDirection: "row" }}>
        <Info height={20} width={20} color="rgba(255, 122, 0, 1)" />
        <CustomText
          variant="body_text_2"
          style={{ color: color.mediumBlack, marginLeft: 8 }}
        >
          {`${returnQty} क्वांटिटी`}
        </CustomText>
        <CustomText variant="body_text_4" style={{ color: color.mediumBlack }}>
          {` सिटीमॉल को वापिस करनी है!`}
        </CustomText>
      </View>
      {isClickable ? (
        <View style={{ height: 18, width: 18 }}>
          <ChevronRight pathFill="rgb(0, 0, 0)" />
        </View>
      ) : null}
    </View>
  ) : null;
};

export default ItemsToReturnStrip;
